type TrpcErrorNotifier = (message: string) => void;

let notifier: TrpcErrorNotifier | null = null;

export const registerTrpcErrorNotifier = (next: TrpcErrorNotifier) => {
  notifier = next;
  return () => {
    if (notifier === next) {
      notifier = null;
    }
  };
};

export const notifyTrpcError = (message: string) => {
  if (notifier) {
    notifier(message);
  }
};
